import { useEffect, useState, useCallback } from "react";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Chip,
  CircularProgress,
} from "@mui/material";
import api from "../../utils/api";

export default function AgentStudents() {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  // server-side pagination state
  const [page, setPage] = useState(0); // MUI uses 0-based
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);

  const loadStudents = useCallback(async () => {
    try {
      setLoading(true);
 const res = await api.get("/agent/dashboard", {
  params: {
    page: page + 1,
    limit: rowsPerPage,
  },
});


setRows(res.data?.rows || []);
setTotal(res.data?.total || 0);

    } catch (err) {
      console.error("Failed to load agent students", err);
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [page, rowsPerPage]);

  useEffect(() => {
    loadStudents();
  }, [loadStudents]);

  return (
    <Box>
      <Typography variant="h5" fontWeight={800} gutterBottom>
        Referred Students
      </Typography>

      <Typography variant="body2" color="text.secondary" mb={2}>
        View all students registered using your referral link.
      </Typography>

      <Paper>
        {loading ? (
          <Box sx={{ p: 4, textAlign: "center" }}>
            <CircularProgress />
          </Box>
        ) : total === 0 ? (
          <Box sx={{ p: 4 }}>
            <Typography>No referred students yet.</Typography>
          </Box>
        ) : (
          <>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Verified</TableCell>
                    <TableCell>Subscription</TableCell>
                    <TableCell>Plan</TableCell>
                    <TableCell>Expiry</TableCell>
                    <TableCell align="right">Amount (₦)</TableCell>
                    <TableCell>Referred On</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {rows.map((row) => (
                    <TableRow key={row.student_id}>
                      <TableCell>{row.full_name}</TableCell>
                      <TableCell>{row.email}</TableCell>

                      <TableCell>
                        <Chip
                          label={row.is_verified ? "Yes" : "No"}
                          color={row.is_verified ? "success" : "default"}
                          size="small"
                        />
                      </TableCell>

                      <TableCell>
                        {row.subscription_status ? (
                          <Chip label={row.subscription_status} color="primary" size="small" />
                        ) : (
                          <Chip label="None" size="small" />
                        )}
                      </TableCell>

                      <TableCell>{row.plan_name || "-"}</TableCell>

                      <TableCell>
                        {row.expiry_date ? new Date(row.expiry_date).toLocaleDateString() : "-"}
                      </TableCell>

                      <TableCell align="right">
                        {Number(row.total_paid || 0).toLocaleString()}
                      </TableCell>

                      <TableCell>
                        {row.referred_at ? new Date(row.referred_at).toLocaleDateString() : "-"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={total}
              page={page}
              onPageChange={(_, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          </>
        )}
      </Paper>
    </Box>
  );
}
